<!--17 Update von Katalog-->
<div class="dx-field">
  <div class="dx-field-label">{{ 'Account' | translate }}</div>
  <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
    <label class="placeLabel {{ selectedCustomer?.length > 0 ? 'placeLabelSmall' : '' }}">ACCOUNT</label>
    <dx-select-box [(value)]="selectedCustomer"
                   [dataSource]="customers"
                   displayExpr="name"
                   [searchEnabled]="true"
                   valueExpr="id"
                   placeholder="">
    </dx-select-box>
  </div>
</div>

<div class="dx-field">
  <div class="dx-field-label">{{ 'Quellkatalog' | translate }}</div>
  <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
    <label class="placeLabel {{ sourceCatalog?.length > 0 ? 'placeLabelSmall' : '' }}">SOURCE CATALOG</label>
    <dx-select-box [(value)]="sourceCatalog"
                   [dataSource]="catalogs"
                   displayExpr="catalogName"
                   [searchEnabled]="true"
                   valueExpr="id"
                   placeholder="">
    </dx-select-box>
  </div>
</div>

<div class="dx-field">
  <div class="dx-field-label">{{ 'Update Template' | translate }}</div>
  <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
    <label class="placeLabel {{ selectedTemplate?.length > 0 ? 'placeLabelSmall' : '' }}">UPDATE TEMPLATE</label>
    <dx-select-box [(value)]="selectedTemplate"
                   [dataSource]="updateTemplates"
                   [searchEnabled]="true"
                   displayExpr="name"
                   valueExpr="id"
                   placeholder="">
    </dx-select-box>
  </div>
</div>

<div class="dx-field">
  <div class="dx-field-label">{{ 'Schlüssel' | translate }}</div>
  <div class="dx-field-value">
    <!--<div class="dx-field-label switch-left">{{ "SUPPLIER_PID" | translate }}</div>
    <dx-switch [(value)]="useEanAsKey"
               switchedOffText="SUPPLIER_PID"
               switchedOnText="INTERNATIONAL_PID"
               (onValueChanged)="onKeyChanged($event)"></dx-switch>
    <div class="dx-field-label switch-right">{{ "INTERNATIONAL_PID" | translate }}</div>-->
    <dx-select-box [(value)]="selectedKey"
                   [dataSource]="keys">
    </dx-select-box>
  </div>
</div>

<!--<div class="dx-field">
  <div class="dx-field-label"></div>
  <div class="dx-field-value">
    <dx-button icon="edit" (onClick)="editTemplatesClick()">
    </dx-button>
  </div>
</div>-->

<div class="dx-field">
  <div class="dx-field-label"></div>
  <div class="dx-field-value">
    <dx-button icon="edit" (onClick)="showEditTemplates()">
    </dx-button>
  </div>
</div>

<np-dialog [popupWidth]="1200"
           [popupHeight]="800"
           [popupTitle]="showPopup ? ('Update Templates' | translate) : ('Update Templates' | translate)"
           [(popupVisible)]="showPopup">

  <div slot="content" class="h-100 d-flex flex-row">
    <updateTemplates [helpSwitch]="false"></updateTemplates>
  </div>
</np-dialog>
